import { Lightning, Utils } from '@lightningjs/sdk'
import { Helper } from '../lib/helper'
import FallbackImage from "./fallback-image";

export interface StarUITemplateSpec extends Lightning.Component.TemplateSpec {
  StarIcon: object
  RatingText: object
}

export default class StarUI extends Lightning.Component<StarUITemplateSpec> implements Lightning.Component<StarUITemplateSpec> {

  static override _template(): Lightning.Component.Template<StarUITemplateSpec> {
    return {
      flex: { direction: 'row'},
      StarIcon: {
        w: 32,
        h: 32,
        type: FallbackImage,
        imgSrc: 'images/ico_star_rating.png',
        alpha: 0.5,
      },
      RatingText: {
        flexItem: { marginLeft: 8 },
        y: 2,
        text: {
          text: '',
          fontSize: 24,
          fontFace: Helper.getFontFamily('Regular'),
          textColor: Helper.getHexaColor("ffffff", 0.5),
        }
      },
    }
  }

  set rating(value: number) {
    const starRating = (value / 100) * 5
    const displayRating = Math.round(starRating * 10) / 10

    this.patch({
      RatingText: {
        text: { text: `${displayRating}/5`, textColor: Helper.getHexaColor("ffffff", 0.5) }
      }
    })
  }
}
